@if (compact) {
  <div class="warranty-state-bar">
    @for (state of states; track state.key; let i = $index; let last = $last) {
      <div class="tick"
           [class.past]="isPast(i)"
           [class.current]="isCurrent(i)"
           [matTooltip]="state.milestone + ' — ' + state.label"
           matTooltipClass="white-tooltip"
           matTooltipPosition="above"
           matTooltipShowDelay="100"></div>
      @if (!last) {
        <div class="seg" [class.past]="isPast(i)"></div>
      }
    }
  </div>
} @else {
  <div class="warranty-state-diagram">
    <div class="title text-type-8">Warranty lifecycle</div>
    <div class="diagram">
      @for (state of states; track state.key; let i = $index; let last = $last) {
        <div class="step" [class.past]="isPast(i)" [class.current]="isCurrent(i)">
          <div class="dot">
            @if (isPast(i)) { <span class="check">✓</span> }
            @else if (isCurrent(i)) { <span class="pulse"></span> }
          </div>
          <div class="label text-type-14">{{ state.label }}</div>
        </div>
        @if (!last) { <div class="connector" [class.past]="isPast(i)"></div> }
      }
    </div>
  </div>
}
